import { NextComponentType, NextPageContext } from 'next';

function withOptionalAuth(Component: NextComponentType) {
  const OptionalAuth = (props: any) => {
    // @ts-ignore - TypeScript compatibility issue with React 18 types
    return <Component {...props} />;
  };

  if (Component.getInitialProps) {
    OptionalAuth.getInitialProps = Component.getInitialProps;
  }

  return OptionalAuth;
}

export default withOptionalAuth;
